import { render, staticRenderFns } from "./NavChildren.vue?vue&type=template&id=690fb6e3&"
import script from "./NavChildren.vue?vue&type=script&lang=js&"
export * from "./NavChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690fb6e3')) {
      api.createRecord('690fb6e3', component.options)
    } else {
      api.reload('690fb6e3', component.options)
    }
    module.hot.accept("./NavChildren.vue?vue&type=template&id=690fb6e3&", function () {
      api.rerender('690fb6e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/NavChildren/NavChildren.vue"
export default component.exports